<script setup>
import Footer from '@/Layouts/Partials/Footer.vue'
import Navbar from '@/Layouts/Partials/Navbar.vue'
import { randomProjects as randomProjectsAction } from '@/actions/App/Http/Controllers/ProjectController'
import axios from 'axios'
import { onMounted, ref } from 'vue'

defineProps({
    meta_title: {
        type: String,
        default: '',
        required: false,
    },

    meta_description: {
        type: String,
        default:
            'Montujeme sádrokartony, foukáme izolace a aplikujeme betonové stěrky v Olomouckém kraji. Kvalitní práce od profesionálů.',
        required: false,
    },

    follow_type: {
        type: String,
        default: 'follow, index',
        required: false,
    },

    keywords: {
        type: String,
        default:
            'montáže sádrokartonu, sádrokarton, montáže, sádrokartonové konstrukce, foukané izolace, foukaná izolace, betonové stěrky, betonová stěrka, sádrokartonové podhledy, sádrokartonové podhled, montáže podhledů, montáže sádrokartonových podhledů',
        required: false,
    },

    meta_canonical: {
        type: String,
        required: false,
    },
})

// get random-projects from the API
const randomProjects = ref([])

onMounted(() => {
    axios
        .get(randomProjectsAction.url())
        .then((response) => {
            randomProjects.value = response.data
        })
        .catch((error) => {
            console.error('Error fetching random projects:', error)
        })
})
</script>

<template>
    <Head>
        <title inertia>{{ meta_title }}</title>

        <meta
            type="description"
            head-key="description"
            name="description"
            :content="meta_description"
            inertia
        />

        <meta
            name="robots"
            :content="follow_type"
        />

        <meta
            name="keywords"
            :content="keywords"
        />

        <link
            v-if="meta_canonical"
            rel="canonical"
            :href="meta_canonical"
        />
    </Head>

    <Navbar :randomProjects="randomProjects" />

    <main class="min-h-screen overflow-x-visible">
        <slot name="content" />

        <slot name="modal" />
    </main>

    <Footer />
</template>
